import styles from '../product-comparison-grid.module.scss';
import cx from 'classnames';

interface ProductCardDescriptionProps {
  shortDescription: string;
}

const ProductCardDescription = ({
  shortDescription
}: ProductCardDescriptionProps) => {
  return (
    <p
      className={cx(
        'cat-u-theme-typography-footnote mb-0',
        styles['product-comparison__card-description'],
        styles['product-comparison__card-ellipsis']
      )}
    >
      {shortDescription}
    </p>
  );
};

export default ProductCardDescription;
